var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGuard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14H14V23H18.5V14Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.5H14V36.5H18.5V27.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14H27.5V23H32V14Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27.5H27.5V36.5H32V27.5Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 41H14V50H18.5V41Z",
    fill: "#030712"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41H27.5V50H32V41Z",
    fill: "#030712"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 28.73H41V5H5V59H34.79V63.5H0.5V5C0.5 3.8 0.98 2.66 1.82 1.82C2.66 0.98 3.8 0.5 5 0.5H41C42.2 0.5 43.34 0.98 44.18 1.82C45.02 2.66 45.5 3.8 45.5 5V28.73Z",
    fill: "#030712"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.08 33.08V52.1C39.08 57.53 42.44 62.75 47.48 65.12L53.54 68L59.6 65.12C64.7 62.87 68 57.74 68 52.1V33.08H39.08ZM63.41 52.1C63.41 55.7 61.13 59.36 57.83 61.01L53.54 62.99L49.28 61.01C45.8 59.27 43.67 55.88 43.67 52.1V37.67H63.41V52.1Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuard);
export default __webpack_public_path__ + "static/media/ic-guard.d7da7646538482b5d90c9c3955bcf3e3.svg";
export { ForwardRef as ReactComponent };